import type { Epic } from 'epics/rxjs';
import { Observable } from 'epics/rxjs';
import { loginConsent } from 'rest/login-consent';
import type { HandleAjaxError } from 'state/actions/flags';

import type { LoginConsentAction, LoginConsentSuccess, LoginConsentFailure } from 'state/actions/login-consent';
import { loginConsentFailure, loginConsentSuccess, LOGIN_CONSENT } from 'state/actions/login-consent';

export const loginConsentEpic: Epic<LoginConsentAction, LoginConsentSuccess | LoginConsentFailure | HandleAjaxError> = (
    action$
) => {
    return action$.ofType(LOGIN_CONSENT).mergeMap((action) => {
        const { param } = action.payload;
        return loginConsent(param)
            .map(({ response }) => loginConsentSuccess(response))
            .catch((error) => {
                return Observable.of(loginConsentFailure(error));
            });
    });
};
